
      import CloseCircleLight from './close-circle-light.vue'
      import type { App, Plugin } from 'vue'

      export const CloseCircleLightPlugin: Plugin = {
        install(app: App) {
          app.component('CloseCircleLight', CloseCircleLight)
        },
      }
      export { CloseCircleLight }
      